import { Button, TableItem } from 'components/atoms';
import { Table } from 'components/organisms';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { PiDownload } from 'react-icons/pi';
import { ICashFlowForm } from 'services/cash-flow/types';
import { getDefaultCurrency } from 'store/state';
import { formatCurrency } from 'utils/global/currency.utils';
import { getMaxFormattedLength } from 'utils/global/getMaxFormattedLength.utils';

const CashFlowRepayments = () => {
  const { values } = useFormikContext<ICashFlowForm>();
  const { t } = useTranslation();

  const defaultCurrency = getDefaultCurrency()?.currencyCode ?? '';

  const amountToRepaymentLength = getMaxFormattedLength(
    values.repayments ?? [],
    e => e?.amount
  );

  return (
    <Table
      // id={"CashFlowRepayments"}
      size='compact'
      data={{
        nodes: values.repayments
          .filter(r => !!r)
          .map((repayment, key) => ({
            id: key,
            ...repayment,
          })),
      }}
      columns={[
        {
          label: t('input.label.settlement'),
          renderCell: ({ repaymentSource }) => (
            <TableItem>
              <TableItem.Text
                text={t(`enum.REPAYMENT_SOURCE.${repaymentSource.name}`) ?? '-'}
              />
            </TableItem>
          ),
        },
        {
          label: t('input.label.net'),
          renderCell: ({ amount }) => (
            <TableItem>
              <TableItem.Text
                text={formatCurrency(amount, {
                  length: amountToRepaymentLength,
                })}
              />
            </TableItem>
          ),
        },
        {
          label: t('input.label.source'),
          renderCell: ({ repaymentSource }) => (
            <TableItem>
              <TableItem.Text
                text={t(`enum.REPAYMENT_SOURCE.${repaymentSource.name}`) ?? '-'}
              />
            </TableItem>
          ),
        },
        {
          label: t('input.label.documentNumber'),
          renderCell: ({ repaymentDocument }) => (
            <TableItem>
              <TableItem.Text text={repaymentDocument.number.value ?? '-'} />
            </TableItem>
          ),
        },
        {
          label: '',
          renderCell: ({ repaymentDocument }) => (
            <TableItem justifyPosition='end'>
              <a
                href={repaymentDocument.path ?? ''}
                download={repaymentDocument.path}
                aria-disabled={!repaymentDocument.path}
                target='_blank'
                rel='noreferrer'>
                <Button
                  type='button'
                  isClear
                  onlyIcon
                  disabled={!repaymentDocument.path}>
                  <Button.Icon icon={<PiDownload />} />
                </Button>
              </a>
            </TableItem>
          ),
        },
      ]}
    />
  );
};

export default CashFlowRepayments;
